<template>
    <div id="consoleIndex" class="consoleIndex">
        <!-- 头部 -->
        <div class="list-container" v-if="!this.currentCase.match(/view\?/g)" id="cmlist">
            <el-collapse v-model="activeList" v-if="consoleItems.length > 0">
                <el-collapse-item v-for="(item, index) in consoleItems" :title="item.name" :name="item.id" :key="index">
                    <ul v-if="item.children.length > 0">
                        <router-link
                            v-for="(item2, index) in item.children"
                            :class="{ activeItem: currentCase === item2.consolePath }"
                            :key="index"
                            @click.native="selectItem(item2.consolePath)"
                            class="listItem subTile"
                            :to="{ path: `/devcenter/console/${item2.consolePath}` }"
                            tag="li"
                        >
                            <i :class="item2.iconfont" style="padding-right: 5%;"></i>
                            {{ item2.name }}
                        </router-link>
                    </ul>
                </el-collapse-item>
            </el-collapse>
        </div>
        <router-view></router-view>
        <uploadFileList v-show="this.$store.state.fileMng.uploadFileListStatus"  ref="uploadFileList" />
    </div>
</template>

<script>
import { axios_post_formData } from 'src/utils/httpUtil';
import uploadFileList from 'src/pages/devCenter/consoleLab/components/upload-file-status';
import { getObjectViewToken } from '../../../utils/modelUtils';

export default {
    name: 'consoleIndex',
    components: {
        uploadFileList,
    },
    data() {
        return {
            activeList: [0, 1, 3],
            currentCase: '',
            consoleItems: [
                {
                    name: '账户管理',
                    id: 0,
                    children: [
                        {
                            name: '账户概览',
                            id: 1,
                            iconfont: 'icon iconfont iconzhanghugailan',
                            consolePath: 'myaccount',
                        },
                    ],
                },
                {
                    name: '应用管理',
                    id: 1,
                    children: [
                        {
                            name: '我的应用',
                            id: 1,
                            iconfont: 'icon iconfont iconxingzhuangbeifen4',
                            consolePath: 'myapp',
                        },
                        {
                            name: '文件管理',
                            id: 2,
                            iconfont: 'icon iconfont iconlujingbeifen',
                            consolePath: 'fileManagement',
                        },
                        {
                            name: '模型组装',
                            id: 3,
                            iconfont: 'icon iconfont iconxingzhuangbeifen1',
                            consolePath: 'modelAssemble',
                        },
                        //20210327 by wyx
                        {
                            name: 'LOD转换',
                            id: 4,
                            iconfont: 'icon iconfont iconxingzhuangbeifen3',
                            consolePath: 'lodLoad',
                        },
                        {
                            name: 'LOD组装',
                            id: 5,
                            iconfont: 'icon iconfont iconxingzhuangbeifen1',
                            consolePath: 'lodAssemble',
                        },
                        // {
                        //     name: '模型对比',
                        //     id: 3,
                        //     iconfont: 'icon iconfont iconxingzhuangbeifen3',
                        //     consolePath: 'modelCompared',
                        // },
                    ],
                },
                {
                    name: '资源管理',
                    id: 3,
                    children: [
                        {
                            name: '分享管理',
                            id: 31,
                            iconfont: 'icon iconfont iconlujingbeifen1',
                            consolePath: 'shareManagement',
                        },
                    ],
                },
            ],
        };
    },
    watch: {
        $route(to, from) {
            const tempPathArr = to.path.split('/');
            this.currentCase = tempPathArr[tempPathArr.length - 1];
        },
    },
    methods: {
        selectItem(index) {
            this.currentCase = index;
        },
    },
    mounted() {
        const tempPathArr = this.$route.path.split('/');
        this.currentCase = tempPathArr[tempPathArr.length - 1];
    },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
.consoleIndex >>>
  .el-collapse
    border 0px
    margin-top 10px
  .el-collapse-item__header
    border 0px
    height 45px
    font-size: 14px;
    color: $font-console;
    padding-left: 27%
  .el-collapse-item__content
    padding-bottom: 10px
  .el-collapse-item__wrap
    border-bottom: 0px
.consoleIndex
  height calc(100% - 60px)
  overflow hidden
  display flex
  .list-container
    width 12%
    min-width 160px
    height 100%
    background-color $background-white
    overflow hidden
    .listItem
      border 0px
      height 45px
      font-size: 14px;
      dom_center()
      box-sizing: border-box;
      &.subTile
        dom_center()
        width 100%
        text-decoration none
        color: $font-console
      &:hover
        cursor pointer
        border-right-width 3px
        border-right-style solid
        border-right-color $border-active
        background-color $background-consoleBlueLight
        &.subTile
          color: $font-activeBlue
    .activeItem
      border-right-width 3px
      border-right-style solid
      border-right-color $border-active
      background-color $background-consoleBlueLight
      &.subTile
        color: $font-activeBlue
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/consoleIndex.vue